import styles from './styles.scss';
import cn from 'classnames';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OverrideStyleInterface = any;
const _styles: OverrideStyleInterface = styles;
// TODO: we should probably redo this and serve the english name of the color,
// or have an enum color in the future?
const characters: { [key: string]: string } = {
  [' ']: '_',
  ['/']: '_',
  ['-']: '_',
  ['å']: 'a',
  ['ä']: 'a',
  ['ö']: 'o',
  ['ø']: 'o',
  ['é']: 'e'
};

export function getClassNameForColour(colour: string): string {
  // eslint-disable-next-line no-useless-escape
  return colour.toLowerCase().replace(/[\/\-\såäöøé]/g, m => characters[m]);
}

interface Props {
  colour: string;
  tooltipOnHover?: boolean;
  className?: string;
  url?: string;
}

export const ColourBox = (props: Props) => (
  <div className={cn(styles.colourBoxWrapper, props.className)}>
    {props.tooltipOnHover && <div className={styles.tooltip}>{props.colour}</div>}
    {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
    <div className={cn(styles.colourBox, _styles[getClassNameForColour(props.colour)])} />
  </div>
);
